import { render, staticRenderFns } from "./LongerLifeIcon.vue?vue&type=template&id=60dee1c8&"
import script from "./LongerLifeIcon.vue?vue&type=script&lang=js&"
export * from "./LongerLifeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports